export const getVersion = state => state.config.version || '0.0.0';
export const getIccUrl = state => state.config.iccUrl;
export const getSalesUrl = state => state.config.salesUrl;
export const getWinbackUrl = state => state.config.winbackUrl;
export const getEnv = state => state.config.environment;